import React from 'react';
import { MessageSquare, Play, Pause } from 'lucide-react';
import { useAudioPlayer } from '../../hooks/useAudioPlayer';
import { VOICE_MODELS } from '../../constants/audio';

export const VoiceSelector = ({ selectedVoiceId, onVoiceSelect }) => {
  const { play, stop, isPlaying, currentId } = useAudioPlayer();

  const handlePreview = async (voiceId, previewUrl) => {
    if (currentId === voiceId && isPlaying) {
      stop();
    } else {
      await play(previewUrl, voiceId, 0.8);
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-4 text-purple-400">
        <MessageSquare className="w-5 h-5" />
        <h2 className="font-semibold">Select Voice</h2>
      </div>
      <div className="bg-gray-800/50 backdrop-blur-xl rounded-2xl p-6 border border-gray-700/50">
        <div className="grid grid-cols-5 gap-4">
          {VOICE_MODELS.map(voice => (
            <div
              key={voice.id}
              onClick={() => onVoiceSelect(voice.id)}
              className={`relative aspect-square rounded-xl cursor-pointer transition-all overflow-hidden group ${
                selectedVoiceId === voice.id
                  ? 'bg-gradient-to-r ' + voice.theme
                  : 'bg-gray-900/50 hover:bg-gray-800/50'
              }`}
            >
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-auto h-full pt-2 opacity-60">
                  <img 
                    src={`/user-icon/${voice.id}.svg`} 
                    alt={voice.name}
                    className="w-full h-full" 
                  />
                </div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-black to-transparent" />
              <div className="absolute inset-0 p-4 flex flex-col">
                <div className="flex justify-end mb-auto">
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handlePreview(voice.id, voice.previewUrl);
                    }}
                    className="p-2 rounded-full bg-black/20 hover:bg-black/40 backdrop-blur-sm transition-colors"
                  >
                    {currentId === voice.id && isPlaying ? (
                      <Pause className="w-5 h-5" />
                    ) : (
                      <Play className="w-5 h-5" />
                    )}
                  </button>
                </div>
                <div className="mt-auto text-center">
                  <h3 className="font-semibold text-white text-sm drop-shadow-lg">
                    {voice.name}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};